module.exports = __webpack_public_path__ + "static/media/tiktok.ebf0fc15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tiktok.svg
// module id = 356
// module chunks = 1